// measure-budget-type.ts
// Type de budget pour une mesure de prévention.
// Mappe vers l'enum API integer : Investment=0, Operation=1

export type MeasureBudgetType = "Investment" | "Operation";

export const BUDGET_TYPE_TO_INT: Record<MeasureBudgetType, 0 | 1> = {
  Investment: 0,
  Operation: 1,
};

export const INT_TO_BUDGET_TYPE: Record<number, MeasureBudgetType> = {
  0: "Investment",
  1: "Operation",
};
